import { render, staticRenderFns } from "./clock.vue?vue&type=template&id=01745f0e&"
import script from "./clock.vue?vue&type=script&lang=js&"
export * from "./clock.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/buildhome/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('01745f0e')) {
      api.createRecord('01745f0e', component.options)
    } else {
      api.reload('01745f0e', component.options)
    }
    module.hot.accept("./clock.vue?vue&type=template&id=01745f0e&", function () {
      api.rerender('01745f0e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/icons/svg/clock.vue"
export default component.exports